const hostname = window.location.hostname.toLowerCase();
let env = "production";
const chatBotIds = {
  live: {
    hy: "https://chatbot.teamsolutions.am/frame/sdk.bundle.js?version=1.7.4&companyId=680b533d4e45371b9ec81850",
    ru: "https://chatbot.teamsolutions.am/frame/sdk.bundle.js?version=1.7.4&companyId=680b5cfa4e45374a317b1a9e",
    en: "https://chatbot.teamsolutions.am/frame/sdk.bundle.js?version=1.7.4&companyId=680b6bfa4e4537719037b0dc",
  },
  testing: {
    hy: "https://teamy.teamsolutions.am/frame/sdk.bundle.js?version=1.7.4&companyId=67ff5e92d56b09978b6845ac",
    ru: "https://teamy.teamsolutions.am/frame/sdk.bundle.js?version=1.7.4&companyId=67ff5e98d56b09978b6845ae",
    en: "https://teamy.teamsolutions.am/frame/sdk.bundle.js?version=1.7.4&companyId=67ff5e9dd56b09978b6845b0",
  },
};

if (hostname.includes("prelive")) {
  env = "prelive";
} else if (hostname.includes("staging")) {
  env = "staging";
} else if (hostname.includes("testing")) {
  env = "testing";
} else if (hostname.includes("local")) {
  env = "testing"; //prelive
}

const config = {
  env,
  defaultLngPrefix: "hy",
  logoutTimer: 60 * 60 * 1000,
  transVersion: 74,
  simpleCryptoSecretKey: "@qVsN@k3p~D7-`S>",
  apiUrl: "http://localhost:3000/api/",
  translationUrl: "http://localhost:3000/myaccount/",
  urlPrefix: "/",
  imgURLPrefix: "",
  // imgURLPrefix: process.env.REACT_APP_API_URL_PRODUCTION + "myaccount/",
  chatBotIds: {},
};

switch (env) {
  case "prelive":
    config.apiUrl = process.env.REACT_APP_API_URL_PRELIVE + "api/";
    config.translationUrl =
      process.env.REACT_APP_API_URL_PRELIVE + "myaccount/";
    config.urlPrefix = "/myaccount/";
    config.imgURLPrefix = process.env.REACT_APP_API_URL_PRELIVE + "myaccount/";
    config.chatBotIds = chatBotIds.testing;
    break;

  case "staging":
    config.apiUrl = process.env.REACT_APP_API_URL_STAGING + "api/";
    config.translationUrl =
      process.env.REACT_APP_API_URL_STAGING + "myaccount/";
    config.urlPrefix = "/myaccount/";
    config.imgURLPrefix = process.env.REACT_APP_API_URL_STAGING + "myaccount/";
    config.chatBotIds = chatBotIds.testing;
    break;

  case "testing":
    config.apiUrl = process.env.REACT_APP_API_URL_TESTING + "api/";
    config.translationUrl =
      process.env.REACT_APP_API_URL_TESTING + "myaccount/";
    config.urlPrefix = "/myaccount/";
    config.imgURLPrefix = process.env.REACT_APP_API_URL_TESTING + "myaccount/";
    config.chatBotIds = chatBotIds.testing;
    break;

  case "production":
    config.apiUrl = process.env.REACT_APP_API_URL_PRODUCTION + "api/";
    config.translationUrl =
      process.env.REACT_APP_API_URL_PRODUCTION + "myaccount/";
    config.urlPrefix = "/myaccount/";
    config.imgURLPrefix = process.env.REACT_APP_API_URL_PRODUCTION + "myaccount/";
    config.chatBotIds = chatBotIds.live;
    break;
  case "local":
    {
      config.apiUrl = process.env.REACT_APP_API_URL_TESTING + "api/";
      config.urlPrefix = "/myaccount/";
      config.imgURLPrefix = process.env.REACT_APP_API_URL_TESTING + "myaccount/";
      config.chatBotIds = chatBotIds.testing;
    }
    break;
  default:
    config.apiUrl = process.env.REACT_APP_API_URL_TESTING + "api/";
    config.translationUrl =
      process.env.REACT_APP_API_URL_TESTING + "myaccount/";
    config.urlPrefix = "/myaccount/";
    config.imgURLPrefix = process.env.REACT_APP_API_URL_TESTING + "myaccount/";
    config.chatBotIds = chatBotIds.testing;
    break;
}

window.config = config;

export default window.config;